import difference from 'lodash/difference'
import intersection from 'lodash/intersection'

/**
 * 
 * @param {string} urlString 
 */
export function getUrlUtmParams(urlString) {
  const empty = {
    url: '',
    urlParams: null,
    urlUtmParams: {},
  }

  if (!urlString) return empty

  try {
    const url = new URL(urlString)
    const urlParams = new URLSearchParams(url.search)

    const utmRegex = /^utm_/i
    const urlUtmParams = Object.fromEntries(
      [...urlParams.entries()].filter(([paramName]) => utmRegex.test(paramName)),
    )

    return {
      url,
      urlParams,
      urlUtmParams,
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('getUrlUtmParams ERROR', urlString, e)
    return empty
  }
}

/**
 * 
 * @param {string} url 
 * @param {Record<string, string>} originUrlUtmParams 
 */
export const replaceUrlUtmParams = (url, originUrlUtmParams) => {
  try {
    const { url: ctaUrl, urlParams: ctaUrlParams, urlUtmParams: ctaUtmParams } = getUrlUtmParams(url)
    if (!ctaUrl || !ctaUrlParams || !ctaUtmParams) return url

    const ctaUtmParamNames = Object.keys(ctaUtmParams)
    const originUrlUtmParamNames = Object.keys(originUrlUtmParams)
    const toAddFromOriginUrl = difference(originUrlUtmParamNames, ctaUtmParamNames)
    const toReplaceByOriginUrl = intersection(ctaUtmParamNames, originUrlUtmParamNames)
    const toDelete = difference(ctaUtmParamNames, toReplaceByOriginUrl)

    const paramNames = [...ctaUrlParams.keys()]
    for (const paramName of paramNames) {
      if (toReplaceByOriginUrl.includes(paramName)) {
        ctaUrlParams.set(paramName, originUrlUtmParams[paramName])
      } else if (toDelete.includes(paramName)) {
        ctaUrlParams.delete(paramName)
      }
    }

    toAddFromOriginUrl.forEach(paramName => ctaUrlParams.set(paramName, originUrlUtmParams[paramName]))

    ctaUrl.search = ctaUrlParams
    const href = ctaUrl.toString()
    return href
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('replaceUrlUtmParams ERROR', url, originUrlUtmParams, e)
    return url
  }
}

export const getCtaText = (button, ctaTextOverride) => {
  if (button.value) {
    return {
      value: ctaTextOverride || button.value,
    }
  }

  return undefined
}
